import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils/cn';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        /*
          Los estados van en tono suave (fondo claro, texto del color), como en la
          maqueta: el blanco sobre amarillo de antes daba 1,5:1 y no se leía, y una
          tabla llena de pastillas sólidas gritaba más que los datos. Los tokens
          (ok, alerta, bloqueo, info) tienen su versión para el modo oscuro.
          Un contador que tiene que verse sólido (la campana) lo pide con su clase.
        */
        destructive: 'border-bloqueo-borde bg-bloqueo-suave text-bloqueo',
        outline: 'text-foreground',
        success: 'border-ok-borde bg-ok-suave text-ok',
        warning: 'border-alerta-borde bg-alerta-suave text-alerta',
        info: 'border-info-borde bg-info-suave text-info',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
